import { useEffect, useState } from "react";

import { queryClient } from "@/app/queryClient";

type SearchExpiryType = "flight" | "hotel";

export function useSearchExpiry(type: SearchExpiryType) {
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const handleSearchExpired = () => {
      setIsExpired(true);
    };

    window.addEventListener("searchresultsexpired", handleSearchExpired);

    return () => {
      window.removeEventListener("searchresultsexpired", handleSearchExpired);
    };
  }, []);

  const closeModalAndClearSearch = () => {
    setIsExpired(false);

    queryClient.removeQueries({
      queryKey: [type === "flight" ? "flights" : "hotels", "search"],
    });
    queryClient.removeQueries({
      queryKey: [
        type === "flight" ? "flight-availability" : "hotel-availability",
      ],
    });
  };

  return {
    isExpired,
    handleResetExpiredSearch: closeModalAndClearSearch,
  };
}
